export const ROOM_IDS = [
  "tech", "ai", "politics", "pictures", "music", "science",
  "business", "gaming", "sports", "movies_tv", "jokes", "satire",
  "books", "food", "travel", "health", "photography", "space",
  "nature", "history", "productivity", "home_garden", "comics",
  "diy", "incrementals",
];

const REL_FMT = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

export function relativeTime(isoString: string): string {
  const diffMs = new Date(isoString).getTime() - Date.now();
  const diffSec = Math.round(diffMs / 1000);
  const diffMin = Math.round(diffSec / 60);
  const diffHr = Math.round(diffMin / 60);
  const diffDay = Math.round(diffHr / 24);
  if (Math.abs(diffSec) < 60) return REL_FMT.format(diffSec, "second");
  if (Math.abs(diffMin) < 60) return REL_FMT.format(diffMin, "minute");
  if (Math.abs(diffHr) < 24) return REL_FMT.format(diffHr, "hour");
  return REL_FMT.format(diffDay, "day");
}
